import React from "react";
import "./Notfound.css";
// App
function Notfound() {
  return (
    <div className="container_Notfound">
      <div className="defenseNo">Not found.</div>
    </div>
  );
}

export default Notfound;
